module.exports = __webpack_public_path__ + "9afe6b6fbb168fc92dcdc23afdb9a234.jpeg";